(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var carousels = document.querySelectorAll('.livana-landing [data-lvl-reviews]');

  carousels.forEach(function (root) {
    var track = root.querySelector('[data-lvl-reviews-track]');
    var nav = root.parentElement
      ? root.parentElement.querySelector('[data-lvl-reviews-nav]')
      : null;
    if (!track || !nav) return;

    var prevBtn = nav.querySelector('[data-lvl-reviews-prev]');
    var nextBtn = nav.querySelector('[data-lvl-reviews-next]');
    var dotsWrap = nav.querySelector('[data-lvl-reviews-dots]');
    var cards = Array.prototype.slice.call(track.children);
    if (!cards.length || !prevBtn || !nextBtn || !dotsWrap) return;

    var dots = [];
    var maxIndex = 0;

    function step() {
      if (cards.length > 1) {
        var d = cards[1].offsetLeft - cards[0].offsetLeft;
        if (d > 0) return d;
      }
      return cards[0].offsetWidth || 1;
    }

    function visibleCount() {
      return Math.max(1, Math.round(track.clientWidth / step()));
    }

    function currentIndex() {
      var i = Math.round(track.scrollLeft / step());
      if (i < 0) i = 0;
      if (i > maxIndex) i = maxIndex;
      return i;
    }

    function goTo(i) {
      if (i < 0) i = 0;
      if (i > maxIndex) i = maxIndex;
      track.scrollTo({ left: i * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    function syncHeight() {
      if (!track.hasAttribute('data-lvl-reviews-fit')) return;
      var card = cards[currentIndex()];
      if (!card) return;
      track.style.setProperty('--lvl-ugc-track-h', card.offsetHeight + 'px');
    }

    function render() {
      var cur = currentIndex();
      for (var d = 0; d < dots.length; d++) {
        var active = d === cur;
        dots[d].classList.toggle('is-active', active);
        dots[d].setAttribute('aria-current', active ? 'true' : 'false');
      }
      prevBtn.disabled = cur <= 0;
      nextBtn.disabled = cur >= maxIndex;
      syncHeight();
    }

    function build() {
      maxIndex = Math.max(0, cards.length - visibleCount());

      if (maxIndex <= 0) {
        nav.classList.add('is-unavailable');
        nav.setAttribute('aria-hidden', 'true');
        prevBtn.disabled = true;
        nextBtn.disabled = true;
        dotsWrap.textContent = '';
        dots = [];
        return;
      }

      nav.classList.remove('is-unavailable');
      nav.removeAttribute('aria-hidden');
      dotsWrap.textContent = '';
      dots = [];
      for (var i = 0; i < maxIndex + 1; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'lvl-reviews__dot';
        dot.setAttribute('aria-label', 'Go to review ' + (i + 1));
        (function (index) {
          dot.addEventListener('click', function () {
            goTo(index);
          });
        })(i);
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }
      render();
    }

    prevBtn.addEventListener('click', function () {
      goTo(currentIndex() - 1);
    });
    nextBtn.addEventListener('click', function () {
      goTo(currentIndex() + 1);
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        render();
        ticking = false;
      });
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(build, 150);
    });

    cards.forEach(function (card) {
      var images = card.querySelectorAll('img');
      for (var i = 0; i < images.length; i++) {
        if (images[i].complete) continue;
        images[i].addEventListener('load', syncHeight);
      }
    });

    build();
  });
})();
